module.exports = __webpack_public_path__ + "img/tisheng.b967a864.png";